import Vue from 'vue'
import VueCurrencyInput from 'vue-currency-input'

Vue.use(VueCurrencyInput, {"globalOptions":{"currency":"USD","precision":2,"allowNegative":true,"distractionFree":false}})
